module.exports = __webpack_public_path__ + "static/img/4410_phase_function_Paper_Points.21a316b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4410_phase_function_Paper_Points.png
// module id = 3g5/
// module chunks = 0